import {
  SideBarItemModel,
  SideBarSubItemModel,
} from "@/models/sideBarModel/sideBarModel";
import sideBarSettings from "../../configs/sideBarSettings/sideBarSettings.json";

class SideBarService {
  getSideBarElements() {
    var sideBarItems = sideBarSettings.Items.map(
      (item) =>
        new SideBarItemModel({
          DisplayName: item.DisplayName,
          DisplayNameLocalizationCode: item.DisplayNameLocalizationCode,
          Description: item.Description,
          DescriptionLocalizationCode: item.DescriptionLocalizationCode,
          Icon: item.Icon,
          RouterName: item.RouterName,
          HasTopSeperator: item.HasTopSeperator,
          SubItems: item.SubItems?.map(
            (subItem) =>
              new SideBarSubItemModel({
                DisplayName: subItem.DisplayName,
                DisplayNameLocalizationCode: subItem.DisplayNameLocalizationCode,
                Description: subItem.Description,
                DescriptionLocalizationCode: subItem.DescriptionLocalizationCode,
                Icon: subItem.Icon,
                RouterName: subItem.RouterName,
                PermissionCode: subItem?.PermissionCode,
                PermissionCodes: subItem?.PermissionCodes,
              })
          ),
        })
    );

    return sideBarItems;
  }
}

export default SideBarService;
